import http from "@services/httpService"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import { PagedResultDto } from "@services/dto/pagedResultDto"
import { downloadFile } from "@lib/helperFile"

class PromotionProgramService {
  public async createOrUpdate(body: any) {
    const res = await http.post(
      "api/services/app/PromotionProgram/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async createOrUpdateSpecial(body: any) {
    const res = await http.post(
      "api/services/app/SpecialPromotionProgram/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async active(id: number, isActive) {
    const res = await http.post(
      "api/services/app/PromotionProgram/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async activeSpecial(id: number, isActive) {
    const res = await http.post(
      "api/services/app/SpecialPromotionProgram/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async bulkActive(id: number[]) {
    const res = await http.post(
      "api/services/app/PromotionProgram/BulkActive",
      id
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/PromotionProgram/Get", {
      params: { id },
    })
    const { result } = res.data
    return result
  }
  public async getSpecial(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/SpecialPromotionProgram/Get", {
      params: { id },
    })
    const { result } = res.data
    return result
  }

  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/PromotionProgram/GetAll", {
      params,
    })
    return res.data.result
  }

  public async getAllSpecial(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get(
      "api/services/app/SpecialPromotionProgram/GetAll",
      {
        params,
      }
    )
    return res.data.result
  }

  public async getList(): Promise<any[]> {
    const res = await http.get("api/services/app/PromotionProgram/GetList", {
      params: { isActive: true },
    })
    const { result } = res.data
    return result
  }

  public async getListSpecial(): Promise<any[]> {
    const res = await http.get(
      "api/services/app/SpecialPromotionProgram/GetList",
      {
        params: { isActive: true },
      }
    )
    const { result } = res.data
    return result
  }

  public async importPromotionProgram(file: File): Promise<any> {
    const formData = new FormData()
    formData.append("file", file)
    const result = await http.post("api/Imports/ImportPromotionProgram", formData, {
      headers: { "content-type": "multipart/form-data" },
    })
    if (result.data?.success === false) {
      const messageKey = result.data?.error?.message || "IncorrectExcelFormat"
      notifyError(LNotification("ERROR"), L(messageKey))
      throw new Error(messageKey)
    }
    notifySuccess(LNotification("SUCCESS"), LNotification("IMPORT_IS_BEING_PROCESSED"))
    return result.data?.result
  }

  public async downloadPromotionProgramTemplate(): Promise<void> {
    const res = await http.get("api/Imports/GetPromotionProgramTemplate", {
      responseType: "blob",
    })
    downloadFile(res.data, "Import-PromotionProgram-Template.xlsx")
  }
}

export default new PromotionProgramService()
